<template>
    <div id="material-gantt" >
        <!-- <div class="top">
            <div class="table_searchbar">
                <el-row :gutter="W?20:0">
                    <el-col :span="W?8:10">
                        <div class="" @keydown.enter="clickSearch()">
                            <span class="title">交付时间：</span>
                            <el-date-picker style="width:230px" v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期"  end-placeholder="结束日期" value-format="yyyy-MM-dd"   ></el-date-picker>
                        </div>
                    </el-col>
                    <el-col :span="W?16:14" >
                        <div style="text-align:right">
                            <el-button icon="el-icon-search" size='mini' type="primary" @click="clickSearch(1)">查询</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div> -->
        <div   style="padding:10px 20px;background:#fff">
            <el-row class='tab'>
                <div class="tab-head">
                    <div class="left-item">
                        <div @click="gotoOder" style='cursor: pointer;'>
                            <i class="el-icon-arrow-left" style="font-size: 18px;padding: 0 10px;"></i>
                        </div>
                        <h4 style="font-size:16px;margin-left:40px">物料列表</h4>
                    </div>
                    <div class="right-item">
                        <div class="scale-select">
                            <div :style="activeIndex==0?{background:'#409EFF',color:'#fff'}:{}" @click="scaleChange(0)">日</div>
                            <div :style="activeIndex==1?{background:'#409EFF',color:'#fff'}:{}" @click="scaleChange(1)">周</div>
                            <div :style="activeIndex==2?{background:'#409EFF',color:'#fff'}:{}" @click="scaleChange(2)">月</div>
                            <div :style="activeIndex==3?{background:'#409EFF',color:'#fff'}:{}" @click="scaleChange(3)">年</div>
                        </div>
                        <div class="explain">
                            <div class="explain-item">
                                <div style="background:#6DB7EE"></div>
                                <span>计划时间</span>
                            </div>
                            <div class="explain-item">
                                <div style="background:#AADC95"></div>
                                <span>实际时间</span>
                            </div>
                            <div class="explain-item">
                                <div style="background:#FF7E55"></div>
                                <span>时间冲突</span>
                            </div>
                        </div>
                        <!-- <div class="select-box">
                            <el-checkbox-group v-model="checkList" @change='selectStatusChange'>
                                <el-checkbox label="未开始"></el-checkbox>
                                <el-checkbox label="生产中"></el-checkbox>
                                <el-checkbox label="已延期"></el-checkbox>
                                <el-checkbox label="已完成" ></el-checkbox>
                            </el-checkbox-group>
                        </div> -->
                    </div>
                </div>
                <div ref="gantt" class="left-container" />
                <div class="page" v-if="page.total > 0">
                    <div class="total_page"><span> 共{{page.total}}条 10条/页</span></div>
                    <div style="margin-top:10px;text-align:right; margin-bottom:20px;" >
                        <el-pagination background layout="prev, pager, next" :total="page.total" @current-change="pageChange" :current-page="tableCurrentPage">
                        </el-pagination>
                    </div>
                </div>
            </el-row>
        </div>
    </div>
</template>

<script>
import gantt from "dhtmlx-gantt"; // 引入模块
import "dhtmlx-gantt/codebase/dhtmlxgantt.css";
import "dhtmlx-gantt/codebase/locale/locale_cn";
import "dhtmlx-gantt/codebase/ext/dhtmlxgantt_tooltip.js";

export default {
    name: "MaterialGantt",
    data() {
        return {
            orderCode:'',
            orderId:null,
            activeIndex:0,
            orderStates:[0,4,2],
            type: 0,
            week:{0:'日', 1:'一', 2:'二', 3:'三', 4:'四', 5:'五', 6:'六', },
            checkList:['未开始','生产中','已延期'],
            statusObj: {未开始:0, 生产中:4,已延期:2, 已完成:1},
            tasks: {
                data: []
            },
            tableTotalPage:0,
            tableCurrentPage:1,
            fristLoad:false,
            tableData:[],
            now : new Date(),
            page: {
                isShow: true,
                total: 0,
                currentPage: 1,
                pageSize: 20,
            },
            W:false,
            searchForm:{},
            dateRange: [new Date(new Date().valueOf() - 30 * 24 * 60 * 60 * 1000), new Date()],
            permission:JSON.parse(localStorage.getItem("permission"))
        };
    },
    computed:{
        span(){
           return this.W?5:7
        },
      
    },
    
    beforeDestroy(){
        if(gantt&&gantt.clearAll){
            gantt.clearAll()
        }
    },
    mounted: function() {
        this.orderId = this.$route.query.orderId
        this.orderCode = this.$route.query.orderCode
        window.status = 8
        let w  = document.documentElement.clientWidth || document.body.clientWidth;
        w>=1900?this.W = true:this.W = false
        window.onresize=()=>{
            let w  = document.documentElement.clientWidth || document.body.clientWidth;
            w>=1900?this.W = true:this.W = false
        }
        this.initGantt([])
    },
    methods: {
        gotoOder(){
            let params = JSON.parse(localStorage.getItem('orderGanttParams')) 
            this.$router.push({path: '/Production/OrderGantt',query: {orderStates:params.orderStates,pageNum:params.pageNum,dateRange:params.dateRange}})
        },
        init: function() {
            this.search();
        },
        initGantt: function(data) {
           this.tasks.data = data
                        
            //配置左侧columns
            gantt.config.columns = [
                {name: "name",label: "订单号 > 物料名称",}
            ];
            //配置左侧列表宽度
            gantt.config.grid_width = 230

            //配置工作日历高度
            gantt.config.scale_height = 70

            gantt.config.drag_resize = false;//两边不可拖动 
            gantt.config.readonly = true;//只读模式

            //设置任务时间格式
            gantt.config.task_date = "%d-%m-%Y %H:%i:%s";
            gantt.config.lightbox_additional_height = 40
            gantt.config.lightbox.sections = []
            //设置最小时间单位
            gantt.config.duration_unit = "hour";
            //配置鼠标滚动缩放时间比例
            gantt.config.min_column_width = 80;
            
            let that = this
            gantt.attachEvent("onGanttReady", function (start,end,task) {
                var tooltips = gantt.ext.tooltips;
                gantt.templates.tooltip_text = function (start, end, task) {
                    if(!task||!task.baseData){
                        return ''
                    }
                    let planBeginTime = '' , planEndTime='' , actualBeginTime='' , actualEndTime='' , progress='' , title;
                    if(task.baseData.planBeginTime){
                        planBeginTime = commonUtils.timestampToDate(task.baseData.planBeginTime)
                    }
                    if(task.baseData.planEndTime){
                        planEndTime = commonUtils.timestampToDate(task.baseData.planEndTime)
                    }
                    if(task.baseData.actualBeginTime){
                        actualBeginTime = commonUtils.timestampToDate(task.baseData.actualBeginTime)
                    }
                    if(task.baseData.actualEndTime){
                        actualEndTime = commonUtils.timestampToDate(task.baseData.actualEndTime)
                    }
                    title =  task.baseData.name
                    if(task.progress){
                        progress = Number(task.progress)*100+'%'
                    }
                    return `
                    <b>物料名称：${title}</b><br/>
                    <b>计划开始时间：${planBeginTime}</b><br/>
                    <b>计划结束时间：${planEndTime}</b><br/>
                    <b>实际开始时间：${actualBeginTime}</b><br/>
                    <b>实际结束时间：${actualEndTime}</b><br/>
                    <b>进度：${progress}</b>
                    `
                };
            })
            gantt.templates.rightside_text = function(start, end, task){
                let text = ''
                if(!task||!task.baseData){
                    return ''
                }
                if(task.type==2&&task.progress){
                    text = '进度：' + Number(task.progress)*100+'%'
                }else if(task.type==1){
                    text = task.baseData.name
                }
                return text
            };
            gantt.attachEvent("onTaskClick", function(id,e){
               let splitId = null
                if(id.endsWith('_1')){
                    splitId = Number(id.split('_1')[0])
                }else{
                    splitId = id
                }
                if(that.tasks){
                    let materialInfo = that.tasks.data.find(item=>item.id==splitId)
                    if(materialInfo){
                        if(window.status>3){
                            that.$router.push({path: '/Production/TechnologyGantt',query:{splitId,orderId:that.orderId,orderCode:that.orderCode,materialCode:materialInfo.baseData.name}})
                        }
                    }
                }
                return false
            });
            let zoomConfig = {
                minColumnWidth: 80,
                maxColumnWidth: 120,
                levels: [
                    [
                        { unit: "day", format: "%Y-%m-%d", step: 1 },
                        { unit: "hour", format: this.hourRangeFormat(), step: 4 }
                    ],
                    [
                        { unit: "week", format: date=>this.parseWeek(date),  step: 1 },
                        {unit: "day", format:date=>this.week[date.getDay()], step: 1,}
                    ],
                    [
                        { unit: "month", format: "%Y-%m", step: 1 },
                        { unit: "week", format: "%m-%d", step: 1 },
                    ],
                    [
                        { unit: "year", format: "%Y", step: 1 },
                        { unit: "month", format: "%M", step: 1 },
                    ],
                ],
                // startDate: new Date(2018, '02', 27),
                // endDate: new Date(2018, '03', 20),
                useKey: "ctrlKey",
                trigger: "wheel",
                element: function() {
                    return gantt.$root.querySelector(".gantt_task");
                }
            };

            gantt.ext.zoom.init(zoomConfig);
            gantt.config.show_tasks_outside_timescale = true;
            gantt.config.fit_tasks = true;
            
            gantt.init(this.$refs.gantt);
            //左侧行样式
            gantt.templates.grid_row_class = function(start, end, task){
                if(task.id.toString().endsWith("_1")){
                    return 'actuals-row'
                }else{
                    return 'plan-row'
                }
            };
            //修改任务进度条颜色
            gantt.templates.task_row_class = function(start,end,task) {
                if (task.id.toString().endsWith("_1")) {
                    return "actuals-task-row";
                } else {
                    return "plan-task-row";
                }
            };
            //修改任务进度条颜色
            gantt.templates.task_class = function(start,end,task) {
                if (task.id.toString().endsWith("_1")) {
                    if(task.isHide){
                        return "hide-task";
                    }else{
                        if(task.delay){
                            return "delay-task";
                        }else{
                            if(task.progress>=1){
                                return "reality-task none-border-task";
                            }else{
                                return "reality-task";
                            }
                            
                        }
                        
                    } 
                } else {
                    return "plan-task";
                }
            };
            
            // 数据解析
            gantt.parse(this.tasks);
            log('初始化完成')
            this.init()
        },
        selectStatusChange(ev){
            this.orderStates = ev.map(item=>this.statusObj[item])
            gantt.clearAll()
            this.search()
        },
        scaleChange(type) {
            if(this.activeIndex==type){
                return
            }else{
               this.activeIndex=type 
            }
            let levels = [
                [
                    { unit: "day", format: "%Y-%m-%d", step: 1 },
                    { unit: "hour", format: this.hourRangeFormat(0), step: 4 }
                ],
                [
                    { unit: "week", format:date=>this.parseWeek(date),  step: 1 },
                    {unit: "day", format:date=>this.week[date.getDay()], step: 1,}
                ],
                [
                    { unit: "month", format: "%Y-%m", step: 1 },
                    { unit: "week", format: "%m-%d", step: 1 },
                ],
                [
                    { unit: "year", format: "%Y", step: 1 },
                    { unit: "month", format: "%M", step: 1 },
                ],
            ];
            gantt.config.scales = levels[type];
            gantt.render();
		},
		parseWeek(date){
            let dateToStr = gantt.date.date_to_str("%Y-%m-%d");
            let  endDate = gantt.date.add(date, 6, "day");
            return dateToStr(date) + '——' + dateToStr(endDate)
        },
        hourRangeFormat(step) {
            return function(date) {
                let  intervalEnd = new Date(gantt.date.add(date, step, "hour"));
                let hourToStr = gantt.date.date_to_str("%H:%i")
                return hourToStr(date) 
            };
        },
        clickSearch(){
            this.search()
        },
        pageChange(page){
            this.search(page)
        },
        search:function(pageNum){
            if(pageNum == null || pageNum instanceof KeyboardEvent){
                pageNum = 1;
            }
            this.activeIndex = 0
            this.page.currentPage = pageNum
            var dateRange = this.dateRange;
            if (dateRange == null || dateRange[0] == null || dateRange[1] == null) {
                this.$message.warning("请选择完整的时间区间");
                return;
            }
            let [startDate,endDate] = dateRange
            startDate = commonUtils.timestampToDate(new Date(startDate).getTime(),true)
            endDate = commonUtils.timestampToDate(new Date(endDate).getTime(),true)
            this.$RequestUtil.post({
                url:'/api/Gantt/getProductGantt',
                type:'sync',
                params: {
                    orderId:this.orderId,
                },
                success: (res) => {
                    if(res.code == 0){
                        let data = []
                        res.data.list.forEach((val, index) => {
                            var item = {};
                            item.baseData = val
                            item.id = val.id;
                            item.text = ''
                            item.delay = val.isDelay
                            item.orderState = val.orderState
                            item.deliverTime = ''
                            item.start_date = commonUtils.timestampToDate2(val.planBeginTime,true)
                            item.end_date = commonUtils.timestampToDate2(val.planEndTime,true)
                            let diff = Math.abs(val.planBeginTime - val.planEndTime)
                            item.duration = parseInt(diff / (1000 * 60 * 60 ))
                            let itemCopy = { ...item }
                            itemCopy.name = this.orderCode+'>'+val.name
                            itemCopy.progress = val.partProcessRatio/ 100
                            if(itemCopy.progress>0&&itemCopy.progress<1){ 
                                itemCopy.end_date = commonUtils.timestampToDate2(val.preEndTime,true)
                                diff = Math.abs(val.actualBeginTime - val.preEndTime);
                                itemCopy.duration = parseInt(diff / (1000 * 60 * 60 ));
                            }else if(itemCopy.progress==0){
                                if(val.actualBeginTime){
                                    itemCopy.progress=0.01
                                    itemCopy.end_date = commonUtils.timestampToDate2(val.actualBeginTime+diff,true)
                                }else{
                                    itemCopy.start_date = null
                                    itemCopy.end_date = null
                                    delete itemCopy.duration
                                    delete itemCopy.progress
                                    itemCopy.isHide = true
                                }
                            }else if(itemCopy.progress>=1){
                                 if(!val.actualEndTime){   //实际结束时间不存在
                                    if(val.planEndTime>=val.actualBeginTime){
                                        val.actualEndTime = val.planEndTime
                                    }else{
                                       val.actualEndTime = new Date().getTime()
                                    }
                                }
                                itemCopy.end_date = commonUtils.timestampToDate2(val.actualEndTime,true)
                                diff = Math.abs(val.actualBeginTime - val.actualEndTime);
                                itemCopy.duration = parseInt(diff / (1000 * 60 * 60 ));
                            }
                            item.progress = itemCopy.progress
                            itemCopy.deliverTime = commonUtils.timestampToDate(val.deliverTime,true);
                            itemCopy.start_date = commonUtils.timestampToDate2(val.actualBeginTime,true);
                            itemCopy.id = val.id + "_1";
                            item.type = 1;
							itemCopy.type = 2;
                            itemCopy.text = ''
                            itemCopy.orderCode = val.name+'|'+val.model
                            data.push(item);
                            data.push(itemCopy);
                        });
                        gantt.clearAll()
                        this.tasks.data=data
                        gantt.init(this.$refs.gantt);
                        gantt.parse(this.tasks);
                        log('更新数据')
                        this.page.total = res.totalPages;
                        // if(res.totalPages == 0){
                        //     this.$message.warning('查询不到符合条件的数据');
                            
                        // }
                    }else{
                        this.$message.error(res.message||res.msg)
                    }
                }
            });
        },
    },
    activated(){
        gantt.parse(this.tasks);
    }
};
</script>

<style scoped>
.tab-head{
    width: 100%;
    border: 1px solid #ccc;
    display:flex;
    height: 66px;
    line-height: 66px;
    box-sizing: border-box;
}
.left-item{
    width: 230px;
    border-right: 1px solid#ccc;
    box-sizing: border-box;
    text-align: center;
    display: flex;
}
.right-item{
    display: flex;
    align-items: center;
}
.scale-select{
    margin-left: 40px;
    width: 244px;
    height: 34px;
    display: flex;
    border: 1px solid #ccc;
    border-right: none;
}
.scale-select div{
    flex: 1;
    text-align: center;
    line-height: 34px;
    border-right: 1px solid #ccc;
    cursor: pointer;
}

.explain{
    margin-left: 60px;
    line-height: 100%;
    display: flex;
}
.explain .explain-item{
    display: flex;
    margin-right: 40px;
}
.explain .explain-item div{
    width: 34px;
    height: 20px;
}
.explain .explain-item span{
    margin-left: 12px;
    padding-top: 4px
}
.select-box{
    margin-left: 200px
}
.top{
    width: 100%;
    height: 50px;
    background: #ffff;
    margin-top: 0px;
    padding-top: 15px;
}
.tabs{
    padding: 5px 20px;
}
.table_searchbar{
    padding: 0 20px;
}
.content{
    /* width: 102.6%; */
    height: auto;
    margin-top: 20px;
    display: flex;
}

.workOrder-deviceTop{
    flex: 1;
    background: #fff;
    padding: 0 20px;
}

.summary span{
    font-size: 14px;
    margin-right: 20px;
}
#material-gantt{
    overflow: hidden;
    overflow-y: auto;
    width: 102.6%;
    scrollbar-width: none;
    height: 102%;
    margin-left: -20px;
    margin-top:-20px;
    background: #f6f7fa;
    /* height: 104%; */
    font-family:'PingFangSC-Regular';
    color:#626266;
    font-size:12px;
}
#material-gantt::-webkit-scrollbar {
    display: none;
}

.search-input-row{
    margin-top: 10px;
}
.page{
    display: flex;
    justify-content: flex-end;
}
.total_page{
    margin-top: 16px;
    margin-right: 16px;
    color:#606266;
    font-size: 14px;
}
@media screen and (max-width: 1380px){
    .page{
        display: flex;
        justify-content: flex-end;
        margin-bottom:30px;
    }

    .summary span{
        font-size: 12px;
    }
}
@media screen and (max-width: 1440px) {
    #material-gantt{
        width: 103.6%;
    }
}
@media screen and (max-width: 1366px) {
    #material-gantt{
        width: 103.8%;
        height: 110%;
    }
    .content{
        padding-bottom: 40px
    }
    .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 180px !important;
    }
}
@media screen and (max-width: 1280px){
    #material-gantt{
        width: 104.2%;
    }
    .number-item {
        padding: 0 6px;
    }
    .number-item span{
        font-size: 26px
    }
    .hour{
        font-size: 14px;
        width: 28px;
    }
}
</style>
<style>
.el-table  .el-table__body .rowbg{
    background:#ffffff !important;
}
.el-table  .el-table__body  .rowbg:hover>td{ background: #ffffff !important; }

#material-gantt .left-container {
    height: 704px;
}
/* .gantt_grid_scale .gantt_grid_head_cell{
    text-align: left;
    padding-left: 5px;
} */
.reality-task .gantt_task_progress {
    background: #AADC95;
	border: none;
}
.reality-task {
    background: none;
	border: 1px dashed #ccc;
    height: 26px !important;
}
.none-border-task{
    border:none
}
.hide-task{
    display: none
}
.delay-task{
    background: none;
	border: 1px dashed #ccc;
    height: 26px !important;
}
.delay-task .gantt_task_progress {
    background: #FF7E55;
	border: none;
}
.plan-task {
    
    height: 26px !important;
    background: rgba(0,0,0,0);
	border: none;
}
.plan-task .gantt_task_progress_wrapper{
    top: 8px;
    background: #6DB7EE;
}
.plan-task .gantt_task_progress {
    background: #6DB7EE;
	border: none;
}
.plan-task .gantt_task_content {
    /* width: 300px; */
    padding-top: 8px
}
/* .reality-task .gantt_task_content {
    width: 80px;
}
.delay-task .gantt_task_content {
    width: 80px;
} */
.plan-task .gantt_side_content.gantt_right {
    top: 6px;
}
.reality-task .gantt_side_content.gantt_right {
    top: -4px;
}
.actuals-row .gantt_cell  .gantt_tree_content{
    position: absolute;
    top: -16px;
    z-index: 9;
}
.plan-row{
    border-bottom: none;
}
.plan-row .gantt_cell .gantt_tree_content{
	position: relative;
	
}
.plan-task-row{
    border-bottom:none
}
.gantt_task_content{
    margin-left: 20px;
    top: -2px;
    color: #000;
    text-align: left;
}
#material-gantt .gantt_grid_head_name{
    position: relative;
    left: 25px;
    text-align: left;
}
</style>




// WEBPACK FOOTER //
// src/views/gantt/materialGantt.vue